import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./home.module.css";

function LandingPage() {

    // useEffect(() => {
    //     // Load user details from localStoragex  
    //     const userData = getUserDetails();
    //     if (userData) {
    //         setUserDetails(userData);
    //     }
    // }, []);

    // Load Google Fonts for this page only
    useEffect(() => {
        const createdLinks = [];

        const linkPreconnectGoogleapis = document.createElement("link");
        linkPreconnectGoogleapis.rel = "preconnect";
        linkPreconnectGoogleapis.href = "https://fonts.googleapis.com";
        document.head.appendChild(linkPreconnectGoogleapis);
        createdLinks.push(linkPreconnectGoogleapis);

        const linkPreconnectGstatic = document.createElement("link");
        linkPreconnectGstatic.rel = "preconnect";
        linkPreconnectGstatic.href = "https://fonts.gstatic.com";
        linkPreconnectGstatic.crossOrigin = "anonymous";
        document.head.appendChild(linkPreconnectGstatic);
        createdLinks.push(linkPreconnectGstatic);

        const linkStylesheet = document.createElement("link");
        linkStylesheet.rel = "stylesheet";
        linkStylesheet.href = "https://fonts.googleapis.com/css2?family=Dosis:wght@200..800&display=swap";
        document.head.appendChild(linkStylesheet);
        createdLinks.push(linkStylesheet);

        return () => {
            createdLinks.forEach((el) => {
                if (el && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            });
        };
    }, []);

    return (
        <>
       <section className={`${styles.header} ${styles.headerCs}`}>
  <div className={`container ${styles.container}`}>
    <div className={styles.logo}>
      <img src={window.getPublicUrl("/images/logo-2.svg")} />
    </div>
    <div className={styles.social}>
      <ul>
        <li><a href="https://www.instagram.com/resumate_official/" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/insta.svg")} /></a></li>
        <li><a href="https://www.facebook.com/people/ResuMate/61579852328938/" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/fb.svg")} /></a></li>
        <li><a href="https://www.tiktok.com/@resumate_official?_t=ZP-90Duf9Ama9W&_r=1" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/tik.svg")} /></a></li>
      </ul>
    </div>
  </div>
</section>

<section className={`${styles.banner} ${styles.bannerChangeCs}`}>
  <div className={`container ${styles.container}`}>
    <div className="row">
      <div className="col-sm-6">
        <div className={styles.bannerText}>
          <h3>Make your Resume, and Meet your Mate Today</h3>
          <h4>Smart matching, video calls, and meaningful connections.</h4>
          <ul>
            <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064"><img src={window.getPublicUrl("/images/app-store.svg")} /></a></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/google.svg")} /></a></li>
          </ul>
        </div>
      </div>
      <div className="col-sm-6">
        <div className={styles.bannerImg}>
          <img src={window.getPublicUrl("/images/banner-img.png")} />
        </div>
      </div>
    </div>
  </div>
</section>

<section className={styles.whatResumate}>
  <div className={`container ${styles.container}`}>
    <div className="row">
      <div className="col-sm-6">
        <div className={styles.aboutText}>
          <h3>What is <strong>ResuMate</strong>?</h3>
          <p>
            ResuMate is a modern matchmaking app where your love story begins with a real resume built on values,
            goals, and compatibility. Discover potential partners through thoughtful resumes, smart filters, and
            secure video calls. Whether you're looking for friendship or a serious relationship, ResuMate makes
            meaningful connections simple and safe.<br /><br />
            Every resume starts with your story, your words, your heart. Our Al doesn't replace your answers; it
            refines them into a clear one-page summary that's easy to read and true to you. The result is a resume
            that's authentic, personal, and uniquely yours.
          </p>
        </div>
      </div>
      <div className="col-sm-6">
        <div className={styles.aboutImg}>
          <img src={window.getPublicUrl("/images/about.png")} />
        </div>
      </div>
    </div>
  </div>
</section>

<section className={styles.service}>
  <div className={`container ${styles.container}`}>
    <div className="row">
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/ser-icon1.svg")} /></span>
          <h3>Values - First</h3>
          <h4>Match based on what truly matters - your core values and beliefs.</h4>
        </div>
      </div>
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/ser-icon2.svg")} /></span>
          <h3>Goal-Oriented</h3>
          <h4>Connect with people who share your life goals and aspirations.</h4>
        </div>
      </div>
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/ser-icon3.svg")} /></span>
          <h3>Authentic</h3>
          <h4>Video verification ensures you're meeting real, genuine people.</h4>
        </div>
      </div>
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/ser-icon4.svg")} /></span>
          <h3>Quality Focused</h3>
          <h4>Fewer, higher-quality matches mean better connections.</h4>
        </div>
      </div>
    </div>
  </div>
</section>

<section className={styles.howResumate}>
  <div className={`container ${styles.container}`}>
    <div className={styles.howResumateTop}>
      <h2>How <strong>ResuMate</strong> Works</h2>
      <h3>Five simple steps to find meaningful connections based on compatibility, not chance.</h3>
    </div>
    <ul>
    <div className={styles.line}><img src={window.getPublicUrl("/images/line.svg")} /></div>

      <li>
        <h5><img src={window.getPublicUrl("/images/ser-top1.svg")} /></h5>
        <span><img src={window.getPublicUrl("/images/how-icon1.svg")} /></span>
        <h3>Filter & Compare</h3>
        <h4>Use smart filters to see compatible matches side-by-side, not endless scrolling.</h4>
      </li>
      <li>
        <h5><img src={window.getPublicUrl("/images/ser-top2.svg")} /></h5>
        <span><img src={window.getPublicUrl("/images/how-icon2.svg")} /></span>
        <h3>Submit Your Résumé</h3>
        <h4>Apply to connect by sharing your relationship résumé with your values and goals.</h4>
      </li>
      <li>
        <h5><img src={window.getPublicUrl("/images/ser-top3.svg")} /></h5>
        <span><img src={window.getPublicUrl("/images/ser-icon3.svg")} /></span>
        <h3>Video Verification Date</h3>
        <h4>Meet face-to-face virtually to ensure authenticity and build real connection.</h4>
      </li>
      <li>
        <h5><img src={window.getPublicUrl("/images/ser-top4.svg")} /></h5>
        <span><img src={window.getPublicUrl("/images/how-icon4.svg")} /></span>
        <h3>Clear Decision</h3>
        <h4>No ghosting or guessing – get clear acceptance or decline after your video call.</h4>
      </li>
      <li>
        <h5><img src={window.getPublicUrl("/images/ser-top5.svg")} /></h5>
        <span><img src={window.getPublicUrl("/images/how-icon5.svg")} /></span>
        <h3>Private Chat Room</h3>
        <h4>If accepted, chat securely and set up your real-life date with confidence.</h4>
      </li>
    </ul>
  </div>
</section>

<section className={`${styles.howResumate} ${styles.different}`}>
  <div className={`container ${styles.container}`}>
    <div className={styles.howResumateTop}>
      <h2>Why <strong>ResuMate</strong> is Different</h2>
      <h3>See how ResuMate transforms the dating experience with intention and respect.</h3>
    </div>
    <div className={styles.diffrentMain}>
      <div className="row">
        <div className="col-sm-4">
          <div className={styles.diffrentLeft}>
            <span><img src={window.getPublicUrl("/images/matching-method.svg")} /></span>
            <h3>Matching Method</h3>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/cross.svg")} /></span>
            <h3>Other Dating Apps</h3>
            <h4>Endless swiping based on photos</h4>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/check.svg")} /></span>
            <h3>ResuMate</h3>
            <h4>Side-by-side comparison of values & goals</h4>
          </div>
        </div>
      </div>
    </div>

    <div className={styles.diffrentMain}>
      <div className="row">
        <div className="col-sm-4">
          <div className={styles.diffrentLeft}>
            <span><img src={window.getPublicUrl("/images/authenticity.svg")} /></span>
            <h3>Profile Authenticity</h3>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/cross.svg")} /></span>
            <h3>Other Dating Apps</h3>
            <h4>Photos can be outdated or fake</h4>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/check.svg")} /></span>
            <h3>ResuMate</h3>
            <h4>Mandatory video verification calls</h4>
          </div>
        </div>
      </div>
    </div>

    <div className={styles.diffrentMain}>
      <div className="row">
        <div className="col-sm-4">
          <div className={styles.diffrentLeft}>
            <span><img src={window.getPublicUrl("/images/Intentions.svg")} /></span>
            <h3>User Intentions</h3>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/cross.svg")} /></span>
            <h3>Other Dating Apps</h3>
            <h4>Mixed intentions, casual to serious</h4>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/check.svg")} /></span>
            <h3>ResuMate</h3>
            <h4>Serious relationships only résumé format</h4>
          </div>
        </div>
      </div>
    </div>

    <div className={styles.diffrentMain}>
      <div className="row">
        <div className="col-sm-4">
          <div className={styles.diffrentLeft}>
            <span><img src={window.getPublicUrl("/images/communication.svg")} /></span>
            <h3>Communication </h3>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/cross.svg")} /></span>
            <h3>Other Dating Apps</h3>
            <h4>Ghosting and unclear responses</h4>
          </div>
        </div>
        <div className="col-sm-4">
          <div className={styles.diffrentMid}>
            <span><img src={window.getPublicUrl("/images/check.svg")} /></span>
            <h3>ResuMate</h3>
            <h4>Clear accept/decline, respectful process</h4>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/swipe.svg")} /></span>
          <h3>No Endless Swiping</h3>
          <h4>Compare thoughtfully</h4>
        </div>
      </div>
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/no.svg")} /></span>
          <h3>No Catfishing</h3>
          <h4>Mandatory video calls</h4>
        </div>
      </div>

      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/serius.svg")} /></span>
          <h3>Serious Intentions</h3>
          <h4>Résumés focus on goals & values</h4>
        </div>
      </div>
      <div className="col-sm-3">
        <div className={styles.serviceMain}>
          <span><img src={window.getPublicUrl("/images/process.svg")} /></span>
          <h3>Respectful Process</h3>
          <h4>Clear accept/decline, no stringing along</h4>
        </div>
      </div>
    </div>
  </div>
</section>

<section className={styles.ready}>
  <div className={`container ${styles.container}`}>
    <div className="row">
      <div className="col-sm-6">
        <div className={styles.readyLeft}>
          <h3>Ready to <strong>Find Your Match</strong>?</h3>
          <h4>Download ResuMate now and start connecting today.</h4>
          <ul>
            <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>          </ul>
        </div>
      </div>
      <div className="col-sm-6">
        <div className={styles.downImg}>
          <img src={window.getPublicUrl("/images/app-down.png")} />
        </div>
      </div>
    </div>
  </div>
</section>

<section className={styles.footer}>
  <div className={`container ${styles.container}`}>
    <div className="row">
      <div className="col-sm-4">
        <div className={styles.footerLeft}>
          <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
        </div>
                <div className={`${styles.footerMid} ${styles.right}`}>
          <h4>Follow us</h4>
          <ul>
            <li><a href="https://www.instagram.com/resumate_official/" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
            <li><a href="https://www.facebook.com/people/ResuMate/61579852328938/" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
            <li><a href="https://www.tiktok.com/@resumate_official?_t=ZP-90Duf9Ama9W&_r=1" target="_blank" rel="noopener noreferrer"><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
          </ul>
        </div>

      </div>
      <div className="col-sm-4">
                <div>
          <ul className={styles.termsConditonList}>
            <li><Link to="/terms&condition" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Terms & Conditions</Link></li>
            <li><Link to="/privacyPolicy" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Privacy Policy</Link></li>
            <li><Link to="/communityGuidelines" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Community Guidelines</Link></li>
            <li><Link to="/eula" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>EULA</Link></li>
            <li><Link to="/safety" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Safety</Link></li>
          </ul>
        </div>
        {/* <div className={styles.footerMid}>
          <h4>Get the app</h4>
          <ul>
            <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>          </ul>
        </div> */}
      </div>
      <div className="col-sm-4">
        {/* <div className={`${styles.footerMid} ${styles.right}`}>
          <h4>Follow us</h4>
          <ul>
            <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
            <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
            <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
          </ul>
        </div> */}
            <div className={styles.footerMid}>
          <h4 className="text-right">Get the app</h4>
          <ul className="text-right">
            <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>          </ul>
        </div>

      </div>
      <div className="col-sm-12">
        <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
      </div>
    </div>
  </div>
</section>

        </>
    );
};

export default LandingPage;
